module.exports = __webpack_public_path__ + "img/0afc1ac314f85966fd089840b852a328.gif";